"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _marketing = require("@/api/marketing");
var _settings = require("@/settings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "GoodList",
  data: function data() {
    return {
      templateRadio: 0,
      merCateList: [],
      roterPre: _settings.roterPre,
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        status_tag: 1,
        keyword: "",
        mer_valid: 1
      },
      multipleSelectionAll: window.form_create_helper.get(this.$route.query.field) || [],
      multipleSelection: [],
      checked: [],
      broadcast_room_id: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.getList();
    var checked = [];
    this.multipleSelectionAll = checked;
    window.addEventListener("unload", function (e) {
      return _this.unloadHandler(e);
    });
  },
  methods: {
    unloadHandler: function unloadHandler() {
      var _this2 = this;
      if (this.multipleSelectionAll.length > 0) {
        if (this.$route.query.field) {
          /* eslint-disable */
          form_create_helper.onOk(function () {
            form_create_helper.set(_this2.$route.query.field, _this2.multipleSelectionAll.map(function (item) {
              return {
                id: item.product_id,
                src: item.cover_img
              };
            }));
            console.log(_this2.multipleSelectionAll);
            localStorage.setItem("broadcastPro", JSON.stringify(_this2.multipleSelectionAll));
            form_create_helper.close(_this2.$route.query.field);
          });
        }
      } else {
        this.$message.warning("请先选择商品");
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;
      this.multipleSelection = val;
      this.multipleSelectionAll = val;
      setTimeout(function () {
        _this3.changePageCoreRecordData();
      }, 50);
    },
    // 设置选中的方法
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.tableData.data.length; i++) {
        if (selectAllIds.indexOf(this.tableData.data[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.tableData.data[i], true);
        }
      }
    },
    // 记忆选择核心方法
    changePageCoreRecordData: function changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      var selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach(function (row) {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      var noSelectIds = [];
      // 得到当前页没有选中的id
      this.tableData.data.forEach(function (row) {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach(function (id) {
        if (selectAllIds.indexOf(id) >= 0) {
          for (var i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    // 列表
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      (0, _marketing.broadcastProListApi)(this.tableFrom).then(function (res) {
        _this4.tableData.data = [];
        _this4.tableData.data = res.data.list;
        _this4.tableData.total = res.data.count;
        _this4.$nextTick(function () {
          this.setSelectRow(); //调用跨页选中方法
        });

        _this4.listLoading = false;
      }).catch(function (res) {
        _this4.listLoading = false;
        // this.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.changePageCoreRecordData();
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.changePageCoreRecordData();
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};
exports.default = _default;